import * as React from "react";
import { UitkFigure, UitkImage } from "uitk-react-images";
import LazyLoad from "react-lazyload";

import { ImageViewModel } from "./UitkGalleryCarousel";
import { AttributionText } from "components/shared/AttributionText/AttributionText";
import { UitkPlaceholderCard } from "uitk-react-cards";
import { observer } from "mobx-react";

interface UitkGalleryCarouselItemProps extends ImageViewModel {
  className?: string;
  index: number;
}

const Attribution = observer((attributionProps) => {
  const { image } = attributionProps;

  if (!image.source) {
    return null;
  }

  return (
    <AttributionText
      source={image.source}
      origin={image.origin}
      attribUrl={image.attribUrl}
      authorName={image.authorName}
      authorUrl={image.authorUrl}
      licenseSuite={image.licenseSuite}
      licenseName={image.licenseName}
      licenseUrl={image.licenseUrl}
    />
  );
});

export class UitkGalleryCarouselItem extends React.PureComponent<UitkGalleryCarouselItemProps> {
  public static displayName = "UitkGalleryCarouselItem";

  public render() {
    const { className, alt, src } = this.props;

    return (
      <div className={`uitk-gallery-carousel-item uitk-cell ${className}`}>
        <LazyLoad
          once={true}
          placeholder={
            <div data-testid={`galleryCarouselItem-${this.props.index}`}>
              <UitkPlaceholderCard className="uitk-image-placeholder" />
              <Attribution image={this.props} />
            </div>
          }
        >
          <UitkFigure key={src} className="all-image-fit-cover">
            <div data-testid={`galleryCarouselItem-${this.props.index}`}>
              <UitkImage alt={alt} src={src} placeholderImage={false} />
              <Attribution image={this.props} />
            </div>
          </UitkFigure>
        </LazyLoad>
      </div>
    );
  }
}
